/**
 * Web client brand strings.
 * Hostname contains `crabgear` (e.g. crabgear.org) → legacy CrabGear program copy and art;
 * otherwise → Commercial Fishermen's Gear Recovery Network branding.
 */
export const IS_CRABGEAR_BRANDING = /crabgear/.test(window.location.hostname);

export const PROGRAM_FULL_NAME = IS_CRABGEAR_BRANDING
  ? 'Crab Industry Lost Fishing Gear Recovery Program'
  : "Commercial Fishermen's Gear Recovery Network";

/**
 * `GearTag` overlay: the tag mark sits in a row-reverse flex band anchored to the right.
 * Nudge the PCFFA mark right so it reads closer to the tag center (vs hugging the left cutouts).
 */
export const GEAR_TAG_LOGO_LAYOUT = {
  widthPx: IS_CRABGEAR_BRANDING ? 21 : 38,
  /** Visual shift toward center (flex row-reverse; increase if mark still feels left) */
  translateXPx: IS_CRABGEAR_BRANDING ? 0 : -8,
};
